import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import geolocationPlugin from '@/plugins/geolocationPlugin';
import i18n from '@/locales';

import Amplify, { Auth } from 'aws-amplify';
import aws_exports from './aws-exports';

import directivas from '@/library/directivas';
import filters from '@/library/filters';

import {getEnvVar} from '@/library/utils/env-vars';

// Amplify.configure(aws_exports);

//Vue.config.productionTip = false;
// Importar config aunque no se use aquí, para verificar que todaa la configuración
// existe en variables de entorno. NO REMOVER ESTE IMPORT.
import * as config from '@/config';

// window.LOG_LEVEL = 'DEBUG';

Amplify.configure({
	...aws_exports
});

Auth.configure({
  refreshHandlers: {
    developer: config.refreshHandler
  }
});

const vue = new Vue({
  router,
  store,
  vuetify,
  geolocationPlugin,
  i18n,
  render: h => h(App)
}).$mount('#app');